import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import TripItem from '../Home/TripItem';
import LoadingSpinner from '../utility/LoadingSpinner';
import PriceNotes from '../utility/PriceNotes';
import Button from '../utility/Button';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import {
  fetchRelatedTrips,
} from '../../actions/trip';

class OtherTrips extends Component {
  constructor(props) {
    super(props);
    this.routeChange = this.routeChange.bind(this);
  }

  routeChange(path) {
    this.props.history.push(path);
  }

  componentDidMount() {
    const { fetchRelatedTrips, theme, slug } = this.props;
    fetchRelatedTrips(slug, theme);
  }

  render() {
    const { trips, loading, title, full, t } = this.props;
    if(loading) {
      return (
        <section className="fe-trip-other">
          <div className="container">
            <div className="row">
              <div className={full ? 'col-lg-12' : 'col-lg-8'}>
                <LoadingSpinner
                  height={200}
                />
              </div>
            </div>
          </div>
        </section>
      );
    }
    return (
      <section className="fe-trip-other">
        <div className="container">
          <div className="row">
            <div className={full ? 'col-lg-12' : 'col-lg-8'}>
              <h4 className="fe-trip-main-heading">{ t(title) }</h4>
              <div className={`fe-trip-other-trips ${full ? 'full' : ''}`}>
                {trips.map((trip) => {
                  return (
                    <div key={trip.id} className="fe-trip-other-trips-item">
                      <TripItem
                        showDuration={false}
                        direct={true}
                        trip={trip}
                      />
                    </div>
                  );
                })}
              </div>
              <Button alt className='showAllGetaways' onClick={() => this.routeChange('/')}>
                {t('home:showGetaways')}
              </Button>
              <PriceNotes />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

OtherTrips.propTypes = {
  trips: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  slug: PropTypes.string.isRequired,
  fetchRelatedTrips: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  full: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

OtherTrips.defaultProps = {
  title: 'trip:otherGetaways',
  full: false,
  slug: '',
  theme: '',
};

const mapStateToProps = ({ tripState, apiState }) => ({
  trips: tripState.relatedTrips,
  loading: tripState.loadingRelated,
  error: apiState.error,
});

const mapDispatchToProps = {
  fetchRelatedTrips,
};

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OtherTrips)));
